module.exports = __webpack_public_path__ + "static/media/360-degrees.960a6394.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sideMenu/icons/360-degrees.svg
// module id = 88
// module chunks = 0